import { render } from "./LeaveApply.vue?vue&type=template&id=308fbd16&scoped=true"
import script from "./LeaveApply.vue?vue&type=script&lang=js"
export * from "./LeaveApply.vue?vue&type=script&lang=js"

import "./LeaveApply.vue?vue&type=style&index=0&id=308fbd16&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308fbd16"]])

export default __exports__